import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";

import {
  DefaultRouter
} from "@tenderd/track-web-utils";
import AuthPage from './App';



const App: React.FunctionComponent<{ props: any }> = (props) => {
  return (
    <DefaultRouter rootPath="auth">
      <AuthPage />
    </DefaultRouter>
  );
};

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: App,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
